exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Postcard-20fb5fd4{overflow:hidden;text-align:left}.imagecells-8da1436e{width:100%;height:500px}@media screen and (max-width: 500px){.imagecells-8da1436e{height:300px;max-width:100%}}\n", ""]);

// Exports
exports.locals = {
	"Postcard": "Postcard-20fb5fd4",
	"imagecells": "imagecells-8da1436e"
};